import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { updatePharmacyListTitle } from '../../actions/metaActions';
import Card from '../elements/Card';

@connect((store) => { return { }; })
class Male extends React.Component {
    constructor(props) {
        super(props);
        this.goToPharmacyList = this.goToPharmacyList.bind(this);
    }

    goToPharmacyList() {
        this.props.dispatch(updatePharmacyListTitle('Other Pharmacies'));
        this.props.history.push('/pharmacylist');
    }
    
    render() {
        return (
            <div>
                <h1 className="ec__font__title text-center">You have two local options</h1>
                <div className="card-container">
                    <p class="ec__font__body ec__font__body--blue text-center">
                        As a guy, you can't take emergency contraception yourself, but you can buy it for a girl that you know.
                    </p>
                    <Card history={this.props.history} title={"Local Kaiser Permanente"} price={"$25"} link={"kaiser"} />
                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Other pharmacies
                            </p>
                            <p className="card__text">
                                $25
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToPharmacyList}>See pharmacies</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Male;


// WEBPACK FOOTER //
// ./src/components/screens/Male.js